"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _getSession2 = _interopRequireDefault(require("./getSession"));

var _constants = require("./constants");

var _default = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var baseUrl, action, label, value, sessionName, validSessionName, _getSession, sessionId, requestData;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            baseUrl = _ref.baseUrl, action = _ref.action, label = _ref.label, value = _ref.value, sessionName = _ref.sessionName;
            validSessionName = sessionName;

            if (!sessionName) {
              console.error("DEFAULTING TO \"".concat(_constants.DEFAULT_SESSION_NAME, "\" as no session name provided"));
              validSessionName = _constants.DEFAULT_SESSION_NAME;
            }

            _getSession = (0, _getSession2["default"])(validSessionName), sessionId = _getSession.sessionId;

            if (!(!sessionId || !baseUrl)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return");

          case 6:
            requestData = {
              action: action,
              label: label,
              value: value
            };
            _context.next = 9;
            return fetch("".concat(baseUrl, "/sessions/").concat(sessionId, "/events/"), {
              body: JSON.stringify(requestData),
              method: 'post'
            }).then(function (res) {
              return res.json();
            }) // eslint-disable-next-line no-console
            ["catch"](function (error) {
              return console.error(error.message);
            });

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports["default"] = _default;